<div class="container">
  <div class="header">
    <h2>Edit channel JSON for {{ vm.availabilityZoneName }}</h2>
  </div>
  <div class="body">
    <p class="buttons">
      <ichannel-button
        [label]="vm.canRevertChanges ? 'Revert Errors' : 'Validated!'"
        [theme]="vm.canRevertChanges ? 'WARNING' : 'GREEN'"
        (click)="vm.revertChangesClickedEventHandler()"
      ></ichannel-button>
      <ichannel-button
        [label]="'COPY'"
        [theme]="'DARK'"
        [copy-clipboard]="vm.channelJson"
        (copied)="vm.copyButtonClickedEventHandler()"
      ></ichannel-button>
      <ichannel-button
        [label]="'Generate a New JSON'"
        [theme]="'DARK'"
        (click)="vm.generateChannelJsonClicked()"
      ></ichannel-button>
      <ichannel-button
        [label]="'Reset'"
        [theme]="'DARK'"
        (click)="vm.resetButtonClickedEventHandler()"
      ></ichannel-button>
      <ichannel-button
        [label]="'APPLY'"
        [theme]="'DARK'"
        (click)="vm.applyButtonClickedEventHandler()"
      ></ichannel-button>
    </p>
    <textarea
      [ngClass]="{ hasErrors: vm.canRevertChanges }"
      cols="100"
      rows="50"
      [(ngModel)]="vm.channelJson"
      (ngModelChange)="vm.channelJsonAreaChanged($event)"
    ></textarea>
  </div>
</div>
